export const CHECKOUT_URL = 'https://decisionclinica.impultienda.ar/checkout/trt'

export const PRICE = 'USD 12.99'

export const TOTAL_VALUE = 'USD 546'
